import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check, Minus } from "lucide-react";
import * as React from "react";

import { cn } from "@/styles/cn";

type CheckboxProps = React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
  partialChecked?: boolean;
  checked?: boolean | "indeterminate";
  onCheckedChange?: (checked: boolean) => void;
};

const Checkbox = React.forwardRef<React.ComponentRef<typeof CheckboxPrimitive.Root>, CheckboxProps>(
  ({ className, partialChecked, onCheckedChange, ...props }, ref) => {
    const handleCheckedChange = React.useCallback(
      (checked: boolean) => {
        if (onCheckedChange) {
          onCheckedChange(checked);
        }
      },
      [onCheckedChange],
    );

    return (
      <CheckboxPrimitive.Root
        ref={ref}
        className={cn(
          "peer h-[15px] w-[15px] shrink-0 cursor-pointer rounded-[2px] border-[2px] border-urbe-border ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:border-urbix-gray-600 data-[state=checked]:border-urbe-primary data-[state=indeterminate]:border-urbe-primary data-[state=checked]:bg-white data-[state=indeterminate]:bg-white data-[state=checked]:text-urbe-primary data-[state=indeterminate]:text-urbe-primary",
          partialChecked && "bg-white text-urbe-primary",
          className,
        )}
        onCheckedChange={handleCheckedChange}
        {...props}
      >
        <CheckboxPrimitive.Indicator
          className={cn("flex items-center justify-center text-current")}
        >
          {props.checked === "indeterminate" || partialChecked ? (
            <Minus className="size-[11px] text-urbe-primary" strokeWidth={4} />
          ) : (
            <Check className="size-[11px] text-urbe-primary" strokeWidth={4} />
          )}
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
    );
  },
);

Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
